import React from 'react';

type Props = {
    type: 'default' | 'already-submitted' | 'expired' | 'unknown';
};

export const SubmitError = ({ type }: Props) => {
    if (type === 'expired') {
        return (
            <>
                <h3>Błąd</h3>
                <p>Głosowanie w tym konkursie zostało już zakończone!</p>
            </>
        );
    }
    if (type === 'already-submitted') {
        return (
            <>
                <h3>Błąd</h3>
                <p>Oddałeś już głos w tym konkursie, w razie pytań, skontaktuj się z nami.</p>
            </>
        );
    }

    return (
        <>
            <h3>Błąd</h3>
            <p>Wystąpił nieoczekiwany błąd, spróbuj ponownie później, lub skontaktuj się z nami!</p>
        </>
    );
};

export default SubmitError;
